import { TrendDirection } from '..'

export const calculateTrend = (currentValue: number, pastValue: number): number =>
  Number((((currentValue - pastValue) / pastValue) * 100).toFixed(1))

export const determineTrendDirection = (trendValue: number): TrendDirection =>
  trendValue === 0
    ? TrendDirection.UNCHANGED
    : trendValue < 0
    ? TrendDirection.NEGATIVE
    : TrendDirection.POSITIVE
